export default function Django_Models() {
  return <div>Django_Models Component</div>;
}
